<template>
  <div
    class="matrix-data-option-div-holder"
    @click="handleDataClick(tag)"
    @mouseover="handleMouseOver"
    @mouseleave="handleMouseOut"
  >
    <div
      v-show="isBack"
      class="back-btn"
    >
      &nbsp;&nbsp;&nbsp;back
    </div>
    <input
      v-show="!isBack && !tag.tags"
      class="checkbox"
      type="checkbox"
      :checked="isChecked"
      @input.stop=""
    >
    <div class="tag-data-option">
      {{ tag.name }}
      {{ tag.tag }}
    </div>
    <div
      v-show="tag.tags"
      class="nested-tags"
    >
      >
    </div>
    <div
      v-show="isOver"
      v-if="type === 'tags'"
      class="option-actions"
    >
      <div
        class="edit-btn"
        @click="handleEdit"
      >
        <img
          class="edit-icon"
          :src="require('@/assets/svg/SVG/edit.svg')"
          alt="Edit"
        >
      </div>
      <div
        class="remove-btn"
        @click="handleRemove"
      >
        <img
          class="x-icon"
          :src="require('@/assets/svg/SVG/x.svg')"
          alt="Delete"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import { useRMTStore } from '@/store/RMTStore';
import { mapStores } from 'pinia';

export default {
  name: 'TagMatrixDataOption',
  props: [
    'tag',
    'isBack',
    'type'
  ],
  data () {
    return {
      isChecked: false,
      isOver: false,
      myTag: null
    };
  },
  computed: {
    ...mapStores(useRMTStore, useModalStore),

    selectedUploadedFileDataTagIds () {
      const RMTStore = useRMTStore();
      return RMTStore.getSelectedUploadedFileData.tagIds;
    },
    selectedUploadedFileDataCollectionIds () {
      const RMTStore = useRMTStore();
      return RMTStore.getSelectedUploadedFileData.collections;
    },
    selectedUploadedFileDataPermissions () {
      const RMTStore = useRMTStore();
      // Brett
      return RMTStore.getSelectedUploadedFileData.permissions;
    },
    editTag () {
      const RMTStore = useRMTStore();
      return RMTStore.editTag;
    }
  },
  watch: {
    selectedUploadedFileDataTagIds () {
      this.isChecked = this.RMTStore.isIncluded(this.$props.tag, this.$props.type);
    },

    selectedUploadedFileDataCollectionIds () {
      this.isChecked = this.RMTStore.isIncluded(this.$props.tag, this.$props.type);
    },

    selectedUploadedFileDataPermissions () {
      this.isChecked = this.RMTStore.isIncluded(this.$props.tag, this.$props.type);
    },
  },
  mounted () {
    if (this.$props.tag) {
      if (this.RMTStore.isIncluded(this.$props.tag, this.$props.type)) {
        this.isChecked = true;
      }
    }
  },
  created () {
    this.myTag = this.$props.tag;
  },
  methods: {
    handleDataClick (tag) {

      // TODO: consolidate these lines into a cleaner routine

     // if (this.$props.type === 'tags') {
        if (tag.tags) {
          this.RMTStore.setSelectedGroup(tag);
        }
        if (!this.isChecked) {
          this.RMTStore.addKeywordToSelection(tag, this.$props.type);
          // this.selectedUploadedFileDataTagIds.push(tag.tagId);
        } else {
          this.RMTStore.removeKeywordFromSelection(tag, this.$props.type);
          // this.RMTStore.removeFromIncluded(tag, this.$props.type);
        }
     // }

     /* if (this.$props.type === 'collections') {

        if (!this.isChecked) {
          this.selectedUploadedFileDataCollectionIds.push(tag.cID);
        } else {
          this.RMTStore.removeFromIncluded(tag, this.$props.type);
        }

      }

      if (this.$props.type === 'permissions') {

        if (!this.isChecked) {
          this.selectedUploadedFileDataPermissions.push(tag.subscriptionId);
        } else {
          this.RMTStore.removeFromIncluded(tag, this.$props.type);
        }

      }*/

      this.handleCheck();
    },
    handleCheck () {
      this.isChecked = !this.isChecked;
    },
    handleMouseOver () {
      this.isOver = true;
    },
    handleMouseOut () {
      this.isOver = false;
    },
    handleEdit (e) {

      e.stopImmediatePropagation();

      this.RMTStore.editTag = this.$props.tag;

      this.RMTStore.selectedTagAddGroup = this.RMTStore.getGroupById(this.editTag);

      this.RMTStore.manageGroupMode = false;
      // this.RMTStore.resetCreateTag();
      this.RMTStore.matrixMode = 'edit';

    },
    handleRemove () {
      this.modalStore.setModalObj({
        promptLabel: 'REMOVE TAG',
        promptDescription: 'Are you sure you want to remove the tag <b>' + this.$props.tag.tag + '</b>?',
        buttonALabel: 'CONFIRM',
        buttonAFunc: this.removeTag,
        buttonBLabel: 'Cancel',
        buttonBFunc: this.cancelRemove
      });
      this.modalStore.showModal('prompt');
    },
    removeTag () {
      this.RMTStore.removeTag(this.$props.tag.tagId);
      this.modalStore.hideModal();
    },
    cancelRemove () {
      this.modalStore.hideModal();
    }
  }
};
</script>

<style scoped>
.matrix-data-option-div-holder {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: stretch;
  width: 100%;
  padding: 6px;
  height: 30px;
}
.matrix-data-option-div-holder:hover {
  background-color: #f5f5f5;
}
.nested-tags {
  background-color: #9c9c9c;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 20px;
}
.back-btn {
  height: 30px;
  width: 100px;
}
.tag-data-option {
  font-size: .8em;
  font-weight: 500;
}
.checkbox {
  margin-left: 10px;
  margin-right: 10px;
}
.option-actions {
  display: flex;
  flex: 1;
  align-self: center;
  align-items: flex-end;
  justify-content: flex-end;
  margin-right: 0px;
}
.edit-btn {
  margin-left: 10px;
  background-color: lightgrey;
  border-radius: 10px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.remove-btn {
  margin-left: 5px;
  background-color: lightgrey;
  border-radius: 10px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.edit-icon,
.x-icon {
  width: 12px;
}
.x-icon {
  width: 10px;
}
</style>